// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModalForm_wrapper__18qtn","show":"ModalForm_show__2R0ZG","modal":"ModalForm_modal__2qiFv"};